import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import Layout from "@/components/layout/Layout";
import HomePage from "@/pages/Home";
import AboutPage from "@/pages/About";
import ExpertisePage from "@/pages/Expertise";
import ServiceDetail from "@/pages/ServiceDetail";
import PrincipalAdvocatePage from "@/pages/PrincipalAdvocate";
import InsightsPage from "@/pages/Insights";
import ContactPage from "@/pages/Contact";
import PrivacyPage from "@/pages/Privacy";
import TermsPage from "@/pages/Terms";
import DisclaimerPage from "@/pages/Disclaimer";
import NotFoundPage from "@/pages/NotFound";
import AdminPage from "@/pages/Admin";

function ShellRoutes() {
  const { pathname } = useLocation();
  // Admin routes render without the marketing layout (no header/footer/disclaimer/whatsapp FAB)
  if (pathname.startsWith("/admin")) {
    return (
      <Routes>
        <Route path="/admin" element={<AdminPage />} />
        <Route path="/admin/*" element={<AdminPage />} />
      </Routes>
    );
  }
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/expertise" element={<ExpertisePage />} />
        <Route path="/expertise/:slug" element={<ServiceDetail />} />
        <Route path="/principal-advocate" element={<PrincipalAdvocatePage />} />
        <Route path="/insights" element={<InsightsPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/terms" element={<TermsPage />} />
        <Route path="/disclaimer" element={<DisclaimerPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </Layout>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ShellRoutes />
        <Toaster
          position="top-center"
          toastOptions={{
            className:
              "!bg-white !text-charcoal !border !border-soft-grey !rounded-none !font-sans",
          }}
        />
      </BrowserRouter>
    </div>
  );
}

export default App;
